//Libs
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
//Componentes material
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core';
//Ícones
import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@material-ui/icons/CheckBoxOutlineBlankOutlined';
//Componentes
import Imagem from '../Imagem';
//Models
import AvaliacaoResposta from '../../models/AvaliacaoResposta';
//Estilos
import ResultadoStyle from '../../styles/ResultadoStyle';

/**
 * Verifica se a opção informada está na lista das respostas selecionadas
 * @param {Number|String} idOpcao Identificação da opção de resposta a ser verificada
 * @param {Array<Number|String>} selecionadas Lista com as opções selecionadas
 * @returns {Boolean} Retorna verdadeiro caso a opção esteja na lista, falso caso contrário
 */
function respostaSelecionada(idOpcao, selecionadas) {
    return !!selecionadas.find(item => parseInt(item) === parseInt(idOpcao));
}

/**
 * Renderiza as opções de resposta, marcando a selecionada pelo usuário
 * @param {AvaliacaoResposta} resposta Objeto contendo os dados da questão e da resposta
 * @param {Object} classes Classes CSS do componente
 * @returns {Object} Retorna os componentes renderizados para as respostas
 */
function renderOpcoes(resposta, indice, classes) {
    let opcao = resposta.opcoes[indice];
    return (
        <Grid container alignItems="center" spacing={1} wrap="nowrap" >
            <Grid item xs="auto" >
                { respostaSelecionada(opcao.id, resposta.resposta) ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon /> }
            </Grid>
            <Grid item xs >
                { opcao.imagem && <Imagem alt={opcao.descricao} src={opcao.imagem} /> }
                <Typography className={classes.texto} >{opcao.descricao}</Typography>
            </Grid>
        </Grid>
    );
}

/**
 * Renderiza as respostas do tipo multiplaEscolha
 * @param {Object} props
 * @param {Array<AvaliacaoResposta>} props.respostas Dados das respostas a serem exibidas
 * @param {AvaliacaoResposta} props.comparar Dados da resposta que será a base para comparação
 * @param {Object} props.classes Classes CSS do componente
 */
function ResultadoQuestaoMultiplaEscolha({ respostas, classes }) {
    if (respostas.length === 0) return 'Nenhuma resposta encontrada';
    
    return (
        <Fragment>
            {
                respostas[0].opcoes.map((opcao, indice, array) => (
                    <TableRow key={opcao.id} className={(respostas[0].opcaoOutros || indice + 1 < array.length ) ? classes.linhaOpcao : classes.linhaOpcaoUltima}>
                        {
                            respostas.map((resposta) => (
                                <TableCell key={resposta.id}>{renderOpcoes(resposta, indice, classes)}</TableCell>
                            ))
                        }
                    </TableRow>
                ))
            }
            {
                //Caso a resposta possua a opção de resposta livre
                respostas[0].opcaoOutros && (
                    <TableRow className={classes.linhaOpcaoUltima}>
                        {
                            respostas.map((resposta) => (
                                <TableCell key={resposta.id}>
                                    <Grid container item alignItems="center" spacing={1} wrap="nowrap" >
                                        <Grid item="auto" >
                                            { resposta.outro ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon /> }
                                        </Grid>
                                        <Grid item xs >
                                            <Typography className={classes.texto} >Outro: {resposta.outro}</Typography>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                            ))
                        }
                    </TableRow>

                )
            }
        </Fragment>
    );
}

ResultadoQuestaoMultiplaEscolha.propTypes = {
    /** Dados das respostas a serem exibidas */
    respostas: PropTypes.arrayOf(PropTypes.instanceOf(AvaliacaoResposta)).isRequired,
    /** Estilos do componente */
    classes: PropTypes.object
};

export default withStyles(ResultadoStyle)(ResultadoQuestaoMultiplaEscolha);